'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';

import { readAllNotifications } from '../../apis/notification/menu';
import { NOTIFICATION_MENU_KEY } from '../../constants/notification-manager';

export const useReadAllNotifications = () => {
  const { user: session } = useAuth();
  const queryClient = useQueryClient();
  return useMutation(() => readAllNotifications(session?.access_token as string), {
    onSuccess: () => {
      queryClient.invalidateQueries(NOTIFICATION_MENU_KEY);
      queryClient.refetchQueries(NOTIFICATION_MENU_KEY);
    },
  });
};
